export default {"src":"/_next/static/media/iotx.d595ac96.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};